import { render } from "./OrderPerformanceBlock.vue?vue&type=template&id=2084b97e&scoped=true&ts=true&lang=pug"
import script from "./OrderPerformanceBlock.vue?vue&type=script&lang=ts"
export * from "./OrderPerformanceBlock.vue?vue&type=script&lang=ts"

import "./OrderPerformanceBlock.vue?vue&type=style&index=0&id=2084b97e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2084b97e"]])

export default __exports__